import TeamVCard from "../../components/vcard/Vcard";
import styles from "./vcard.module.scss";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
const queryClientContact = new QueryClient();

const VCardPage = () => {
  return (
    <QueryClientProvider client={queryClientContact}>
      <div className={styles.cardPage}>
        <TeamVCard />
      </div>
    </QueryClientProvider>
  );
};

export default VCardPage;
